import moment from 'moment';
import {
  requestApi,
  requestFileApi,
  API_END_POINT,
} from '../../common/api';
import {
  UPLOAD_COMPANY_TAB,
  DATE_TIME_FORMAT,
  RESULT_CODE,
} from '../../common/const';
import {
  setErrorMessage,
} from './CommonAction';

/**
 * state初期化のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_INIT_MATCHING_STATE = 'MATCHING/SET_INIT_MATCHING_STATE';

/**
 * state初期化
 */
export const setInitMatchingState = () => ({
  type: SET_INIT_MATCHING_STATE,
});

/**
 * 企業情報マッチングの表示タブ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_TAB = 'MATCHING/SET_DISP_TAB';

/**
 * 企業情報マッチングの表示タブ設定
 * @param   {string}  dispTab 企業情報マッチングの表示タブ
 */
export const setDispTab = (dispTab) => ({
  type: SET_DISP_TAB, dispTab,
});

/**
 * 表示年月日設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DISP_DATE = 'MATCHING/SET_DISP_DATE';

/**
 * 表示年月日設定
 * @param   {string}  dispDate 表示年月日
 */
export const setDispDate = (dispDate) => ({
  type: SET_DISP_DATE, dispDate,
});

/**
 * 選択シーケンスID設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_SEQUENCE_ID = 'MATCHING/SET_SELECT_SEQUENCE_ID';

/**
 * 選択シーケンスID設定
 * @param   {string}  selectSequenceId 選択シーケンスID
 */
export const setSelectSequenceId = (selectSequenceId) => ({
  type: SET_SELECT_SEQUENCE_ID, selectSequenceId,
});

/**
 * ジョブ一覧設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_JOB_LIST = 'MATCHING/SET_JOB_LIST';

/**
 * ジョブ一覧設定
 * @param   {object}  jobList ジョブ一覧
 */
export const setJobList = (jobList) => ({
  type: SET_JOB_LIST, jobList,
});

/**
 * 選択ジョブ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_SELECT_JOB = 'MATCHING/SET_SELECT_JOB';

/**
 * 選択ジョブ設定
 * @param   {object}  selectJob 選択ジョブ
 */
export const setSelectJob = (selectJob) => ({
  type: SET_SELECT_JOB, selectJob,
});

/**
 * アップロードメモ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_UPLOAD_MEMO = 'MATCHING/SET_UPLOAD_MEMO';

/**
 * アップロードメモ設定
 * @param   {String}  uploadMemo アップロードメモ
 */
export const setUploadMemo = (uploadMemo) => ({
  type: SET_UPLOAD_MEMO, uploadMemo,
});

/**
 * 文字コード設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_CHAR_CODE = 'MATCHING/SET_CHAR_CODE';

/**
 * 文字コード設定
 * @param   {String}  charCode 文字コード
 */
export const setCharCode = (charCode) => ({
  type: SET_CHAR_CODE, charCode,
});

/**
 * 区切り文字設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_DELIMITER = 'MATCHING/SET_DELIMITER';

/**
 * 区切り文字設定
 * @param   {String}  delimiter 区切り文字
 */
export const setDelimiter = (delimiter) => ({
  type: SET_DELIMITER, delimiter,
});

/**
 * 年月日エラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_DISP_DATE = 'MATCHING/SET_ERR_DISP_DATE';

/**
 * 年月日エラーフラグ設定
 * @param   {boolean}  errDispDate 年月日エラーフラグ
 */
export const setErrDispDate = (errDispDate) => ({
  type: SET_ERR_DISP_DATE, errDispDate,
});

/**
 * マッチングファイルエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_MATCHING_FILE = 'MATCHING/SET_ERR_MATCHING_FILE';

/**
 * マッチングファイルエラーフラグ設定
 * @param   {boolean}  errMatchingFile マッチングファイルエラーフラグ
 */
export const setErrMatchingFile = (errMatchingFile) => ({
  type: SET_ERR_MATCHING_FILE, errMatchingFile,
});

/**
 * アップロードメモエラーフラグ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_UPLOAD_MEMO_FLG = 'MATCHING/SET_ERR_UPLOAD_MEMO_FLG';

/**
 * アップロードメモエラーフラグ設定
 * @param   {boolean}  errUploadMemoFlg アップロードメモエラーフラグ
 */
export const setErrUploadMemoFlg = (errUploadMemoFlg) => ({
  type: SET_ERR_UPLOAD_MEMO_FLG, errUploadMemoFlg,
});

/**
 * アップロードメモエラーメッセージ設定のAction識別文字列
 * @type    {string}  Action識別文字列
 */
export const SET_ERR_UPLOAD_MEMO_MSG = 'MATCHING/SET_ERR_UPLOAD_MEMO_MSG';

/**
 * アップロードメモエラーメッセージ設定
 * @param   {String}  errUploadMemoMsg アップロードメモエラーメッセージ
 */
export const setErrUploadMemoMsg = (errUploadMemoMsg) => ({
  type: SET_ERR_UPLOAD_MEMO_MSG, errUploadMemoMsg,
});

/**
 * マッチングジョブ一覧取得
 * @param {string} excutionDate 処理実行日
 */
export const searchMatchingJobList = (excutionDate) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    excution_date: excutionDate,
  };
  // マッチングジョブ一覧取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.MATCHING_COMPANY_MATCHING_JOBLIST, o);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // ステートを初期化
    dispatch(setInitMatchingState());
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    // 画面表示日付を設定
    dispatch(setDispDate(excutionDate));
    return false;
  }
  // ジョブ一覧を設定
  dispatch(setErrorMessage());
  dispatch(setJobList(ret.response.matching_list));
  // 画面表示日付を設定
  dispatch(setDispDate(excutionDate));
  return true;
};
/**
 * ジョブ一覧からシーケンスIDをキーにジョブを抽出
 * @param {string} sequenceId シーケンスID
 */
export const filterJobList = () => async (dispatch, getState) => {
  const {
    selectSequenceId,
    dispDate,
  } = getState().matching;
  const o = {
    seq_id: selectSequenceId,
  };
  // ジョブ一覧から選択シーケンスIDと一致するジョブを抽出
  const job = await requestApi(dispatch, API_END_POINT.MATCHING_COMPANY_MATCHING_HISTORY, o);
  if (!job) {
    // 選択ジョブを初期化
    dispatch(setSelectJob());
    return false;
  }
  if (job.result !== RESULT_CODE.SUCCESS) {
    // ステートを初期化
    dispatch(setInitMatchingState());
    // 年月日で一覧を再取得
    await dispatch(searchMatchingJobList(dispDate));
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(job.response));
    return false;
  }
  // 選択ジョブを設定
  dispatch(setErrorMessage());
  dispatch(setSelectJob(job.response));
  return true;
};

/**
 * ファイルアップロード
 * @param {File}}} uploadFile アップロードするファイル
 * @param {String}} uploadMemo アップロードメモ
 */
export const fileUploadExecute = (
  uploadFile,
  uploadMemo,
  charCode,
  delimiter,
) => async (dispatch) => {
  // リクエストパラメータ生成
  const f = new FormData();
  f.append('upload_file', uploadFile);
  f.append('upload_memo', uploadMemo);
  f.append('char_code', charCode);
  f.append('delimiter', delimiter);
  // マッチングファイルアップロードAPIへリクエスト
  const xhr = await requestFileApi(dispatch, API_END_POINT.MATCHING_COMPANY_UPLOAD);
  // レスポンスが正常の場合の処理
  xhr.oncsuccess = async () => {
    const response = JSON.parse(xhr.responseText);
    if (response.seq_id) {
      // 返却されたシーケンスIDを選択シーケンスIDに設定
      dispatch(setSelectSequenceId(response.seq_id));
    }
    // ジョブ一覧をシステム日時で再取得
    const paramList = {
      excution_date: moment().format(DATE_TIME_FORMAT.DATE),
    };
    dispatch(setDispDate(moment().format(DATE_TIME_FORMAT.DATE)));
    const retList = await requestApi(dispatch,
      API_END_POINT.MATCHING_COMPANY_MATCHING_JOBLIST, paramList);
    if (retList) {
      if (retList.result !== RESULT_CODE.SUCCESS) {
        // ステートを初期化
        dispatch(setInitMatchingState());
        // エラーが発生した場合、エラーメッセージを表示
        dispatch(setErrorMessage(retList.response));
      } else {
        // ジョブ一覧を設定
        dispatch(setJobList(retList.response.matching_list));
        // ジョブ一覧から対象ジョブを抽出
        const paramHistory = {
          seq_id: response.seq_id,
        };
        const retHistory = await requestApi(dispatch,
          API_END_POINT.MATCHING_COMPANY_MATCHING_HISTORY, paramHistory);
        if (retHistory) {
          if (retHistory.result !== RESULT_CODE.SUCCESS) {
            // ステートを初期化
            dispatch(setInitMatchingState());
            // エラーが発生した場合、エラーメッセージを表示
            dispatch(setErrorMessage(retHistory.response));
          } else {
            // メッセージエリア初期化
            dispatch(setErrorMessage());
            // 選択ジョブを設定
            dispatch(setSelectJob(retHistory.response));
            // 表示タブを「データ更新結果」に設定
            dispatch(setDispTab(UPLOAD_COMPANY_TAB.RESULT));
          }
        }
      }
    }
  };
  xhr.send(f);
};

/**
 * ファイル作成
 * @param {string} seqId     シーケンスID
 * @param {string} charCode  文字コード
 * @param {string} delimiter 区切り文字
 */
export const fileCreateExecute = (seqId, charCode, delimiter) => async (dispatch) => {
  // リクエストパラメータ設定
  const o = {
    seq_id: seqId,
    char_code: charCode,
    delimiter,
  };
  // ファイル作成APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.MATCHING_COMPANY_CREATE, o);
  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  return true;
};

/**
 * ファイルダウンロード
 * @param {string} seqId   シーケンスID
 * @param {string} fileName ファイル名
 */
export const fileDownloadExecute = (seqId, fileName) => async (dispatch) => {
  // リクエストパラメータ生成
  const o = {
    seq_id: seqId,
  };
  // ファイル取得APIへリクエスト
  const ret = await requestApi(dispatch, API_END_POINT.MATCHING_COMPANY_DONWLOAD, o, false, true);

  if (ret.result !== RESULT_CODE.SUCCESS) {
    // エラーが発生した場合、エラーメッセージを表示
    dispatch(setErrorMessage(ret.response));
    return false;
  }
  // ダウンロード処理
  const downLoadLink = document.createElement('a');
  document.body.appendChild(downLoadLink);
  downLoadLink.download = fileName;
  downLoadLink.href = window.URL.createObjectURL(ret.response);
  downLoadLink.click();

  return true;
};
